/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loader[_ngcontent-%COMP%]{color:#ffb822;font-size:1.3rem}\n/*# sourceMappingURL=widget-my-steps.component.css.map*/"];
export { styles as styles };
